
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import classnames from 'classnames'

export default class ColorLegend extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    inverted: PropTypes.bool,
    visible: PropTypes.bool
  }

  render() {
    const {
      title,
      inverted,
      visible
    } = this.props

    const classNames = classnames('color-legend', {
      'is-visible': visible
    })

    return (
      <div className={classNames}>
        <Icon
          tooltipPlace='bottom'
          tooltipAlign='start'
          tooltipStyle='default'
          tooltip={(<div className='color-legend_body'>
            <p>
              {title}
            </p>
            {inverted
              ? <p>
                A <span className='color-legend_item is-green'>green area{` `}<b /></span> means that the value{` `}
                for the current period is lower than for the previous and a{` `}
                <span className='color-legend_item is-red'>red area{` `}<b /></span> means the opposite.
              </p>
              : <p>
                A <span className='color-legend_item is-green'>green area{` `}<b /></span> means that the value{` `}
                for the current period is higher than for the previous and a{` `}
                <span className='color-legend_item is-red'>red area{` `}<b /></span> means the opposite.
              </p>
            }
          </div>)}
          name='tooltip-question'
          size='20px'
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/ColorLegend/index.js